export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70864b0cb68b65de763e8999d06beb47723f6618a7&name=pushAdClickData!'